/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Pricing_Feature_Lowest_FeesInputs */

const en_pricing_feature_lowest_fees = /** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% Platform Fee`)
};

const es_pricing_feature_lowest_fees = /** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% de Tarifa de Plataforma`)
};

const fr_pricing_feature_lowest_fees = /** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frais de plateforme de ${i?.fee} %`)
};

const de_pricing_feature_lowest_fees = /** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% Plattformgebühr`)
};

const id_pricing_feature_lowest_fees = /** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Biaya Platform ${i?.fee}%`)
};

/** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */
const ja_pricing_feature_lowest_fees = en_pricing_feature_lowest_fees;

/** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */
const zh_pricing_feature_lowest_fees = en_pricing_feature_lowest_fees;

/** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */
const ar_pricing_feature_lowest_fees = en_pricing_feature_lowest_fees;

/** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */
const it_pricing_feature_lowest_fees = en_pricing_feature_lowest_fees;

/** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */
const ru_pricing_feature_lowest_fees = en_pricing_feature_lowest_fees;

/** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */
const pt_pricing_feature_lowest_fees = en_pricing_feature_lowest_fees;

/** @type {(inputs: Pricing_Feature_Lowest_FeesInputs) => LocalizedString} */
const ko_pricing_feature_lowest_fees = en_pricing_feature_lowest_fees;

/**
* | output |
* | --- |
* | "{fee}% Platform Fee" |
*
* @param {Pricing_Feature_Lowest_FeesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_lowest_fees = /** @type {((inputs: Pricing_Feature_Lowest_FeesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Lowest_FeesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_lowest_fees(inputs)
	if (locale === "es") return es_pricing_feature_lowest_fees(inputs)
	if (locale === "fr") return fr_pricing_feature_lowest_fees(inputs)
	if (locale === "de") return de_pricing_feature_lowest_fees(inputs)
	if (locale === "ja") return ja_pricing_feature_lowest_fees(inputs)
	if (locale === "zh") return zh_pricing_feature_lowest_fees(inputs)
	if (locale === "ar") return ar_pricing_feature_lowest_fees(inputs)
	if (locale === "id") return id_pricing_feature_lowest_fees(inputs)
	if (locale === "it") return it_pricing_feature_lowest_fees(inputs)
	if (locale === "ru") return ru_pricing_feature_lowest_fees(inputs)
	if (locale === "pt") return pt_pricing_feature_lowest_fees(inputs)
	return ko_pricing_feature_lowest_fees(inputs)
});